const ratingValues = [
  {
    value: '1',
    text: '1'
  },
  {
    value: '2',
    text: '2'
  },
  {
    value: '3',
    text: '3'
  },
  {
    value: '4',
    text: '4'
  },
  {
    value: '5',
    text: '5'
  },
  {
    value: '6',
    text: '6'
  },
  {
    value: '7',
    text: '7'
  },
  {
    value: '8',
    text: '8'
  },
  {
    value: '9',
    text: '9'
  }
];

const questionHeader = {
  type: 'html',
  name: 'HTML_QUESTION_Header',
  html: `
  <div class="">
    <span style="font-size:16px;">
      Por favor indica en qué medida estas afirmaciones te representan utilizando la siguiente escala:
    </span>
    <br />
    <br />
  </div>
  `
};

export const TestIntro = {
  locale: 'es',
  title: '',
  completedHtml:
    '<div style="display: flex; justify-content: center; align-items: center; height: 40vh;"><h4>Guardando respuestas para avanzar...</h4></div>',
  startSurveyText: 'Continuar',
  // showProgressBar: 'top',
  // progressBarType: 'questions',
  goNextPageAutomatic: false,
  firstPageIsStarted: false,
  showPrevButton: false,
  showNavigationButtons: true,
  pageNextText: '→',
  pagePrevText: '←',
  showQuestionNumbers: 'off',
  requiredText: `*`,
  pages: [
    {
      name: 'PARTNER_PAGE_01',
      title: '',
      elements: [
        {
          type: 'html',
          name: 'HTML_DIALOG_01',
          html: `
  <div class="QuestionText BorderColor">
    <span style="font-size:16px;">
      <span style="font-family:arial,helvetica,sans-serif;">
        <h3>Instrucciones</h3>
      </span>
      <br />
      Continuando con el ejercicio, la siguiente lista de afirmaciones representa diversas dificultades que las personas suelen tener al momento de decidir qué hacer al terminar el colegio.
      <br />
      <br />
      Por favor indica en qué medida estas afirmaciones te representan usando una escala de <strong>1</strong> (No me representa para nada) a <strong>9</strong> (Me representa muy bien), tal como se presenta a continuación:
      <br />
      <br />
      <div class="qstn-likert-label top">
        <div>No me representa para nada</div>
      </div>
      <div class="btn-group">
        <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="DI_00" aria-required="true" aria-label="1" value="1"><span class="quanta_q_rating_item_text"><span>1</span></span></label>
        <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="DI_00" aria-required="true" aria-label="2" value="2"><span class="quanta_q_rating_item_text"><span>2</span></span></label>
        <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="DI_00" aria-required="true" aria-label="3" value="3"><span class="quanta_q_rating_item_text"><span>3</span></span></label>
        <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="DI_00" aria-required="true" aria-label="4" value="4"><span class="quanta_q_rating_item_text"><span>4</span></span></label>
        <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="DI_00" aria-required="true" aria-label="5" value="5"><span class="quanta_q_rating_item_text"><span>5</span></span></label>
        <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="DI_00" aria-required="true" aria-label="6" value="6"><span class="quanta_q_rating_item_text"><span>6</span></span></label>
        <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="DI_00" aria-required="true" aria-label="7" value="7"><span class="quanta_q_rating_item_text"><span>7</span></span></label>
        <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="DI_00" aria-required="true" aria-label="8" value="8"><span class="quanta_q_rating_item_text"><span>8</span></span></label>
        <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="DI_00" aria-required="true" aria-label="9" value="9"><span class="quanta_q_rating_item_text"><span>9</span></span></label>
      </div>
      <div class="qstn-likert-label bottom">
        <div>Me representa muy bien</div>
      </div>
    </span>
  </div>
`
        }
      ]
    }
  ]
};

const ITEMS = [
  {
    code: 'DI_01',
    text:
      'No tengo claro qué información necesito para poder tomar una decisión sobre mi futura carrera'
  },
  {
    code: 'DI_02',
    text:
      'Encuentro difícil tomar una decisión sobre qué estudiar porque no sé qué pasos seguir para tomar esa decisión'
  },
  {
    code: 'DI_03',
    text:
      'Me es difícil tomar una decisión sobre mi carrera porque no sé qué cosas tengo que considerar para tomar la mejor decisión'
  },
  {
    code: 'DI_04',
    text:
      'Me cuesta tomar una decisión porque no sé como relacionar mis capacidades e intereses con la información que tengo sobre diferentes carreras'
  },
  {
    code: 'DI_05',
    text:
      'Todavía no tengo claro cuáles son las carreras que podrían interesarme'
  },
  {
    code: 'DI_06',
    text:
      'No tengo suficiente información sobre mis habilidades (por ejemplo habilidades verbales, numéricas, etc.), o mis características personales (como persistencia, iniciativa, paciencia, etc)'
  },
  {
    code: 'DI_07',
    text:
      'Encuentro difícil tomar una decisión sobre mi carrera porque no tengo claro qué tipo de trabajo me gustaría hacer en un futuro (por ejemplo, qué ambiente de trabajo prefiero, que tipos de trabajo me gustaría hacer más, etc.).'
  },
  {
    code: 'DI_08',
    text:
      'Siento que tengo poca claridad sobre lo que realmente me gusta para poder elegir qué carrera estudiar'
  },
  {
    code: 'DI_09',
    text:
      'No tengo información suficiente sobre la variedad de carreras ni programas de estudio que existen'
  },
  {
    code: 'DI_10',
    text: 'No se cómo serán en un futuro las carreras que me interesan'
  },
  {
    code: 'DI_11',
    text:
      'Me atraen de igual forma muchas carreras y me es difícil elegir una sola'
  },
  {
    code: 'DI_12',
    text:
      'La carrera que me interesa tiene algunas características que no me atraen (por ejemplo, me interesa medicina, pero no quiero estudiar tantos años)'
  },
  {
    code: 'DI_13',
    text:
      'Mis preferencias no encajan en una única carrera, y no quiero renunciar a lo que quiero (por ejemplo, preferiría una carrera que me permitiera trabajar como independiente, pero también quiero un sueldo estable)'
  },
  {
    code: 'DI_14',
    text:
      'Mis habilidades y características no calzan con los requisitos de las carreras que me gustaría estudiar'
  },
  {
    code: 'DI_15',
    text:
      'Las personas que son importantes para mi (como familia o amigos) no están de acuerdo con las opciones de carrera que estoy considerando'
  },
  {
    code: 'DI_16',
    text:
      'Distintas personas me han dado recomendaciones contradictorias y variadas sobre la carrera que debería seguir o los factores que debería considerar en mi decisión'
  },
  {
    code: 'DI_17',
    text:
      'Me complica que alguno/as docentes piensen que yo debería dedicarme a algo que no me interesa'
  },
  {
    code: 'DI_18',
    text:
      'Me preocupa que mis intereses de carrera no coincidan con lo que otros piensan que debería estudiar'
  },
  {
    code: 'DI_19',
    text:
      'Encuentro difícil tomar una decisión sobre mi carrera porque cambio constantemente mis preferencias profesionales (por ejemplo, a veces quiero ser independiente y otras veces prefiero trabajar en una empresa)'
  },
  {
    code: 'DI_20',
    text:
      'Me es difícil tomar una decisión sobre mi carrera porque tengo información contradictoria sobre mis habilidades o mi personalidad (por ejemplo, creo que soy paciente con otras personas, pero otros dicen que soy impaciente).'
  },
  {
    code: 'DI_21',
    text:
      'Me cuesta elegir una carrera porque tengo información  confusa sobre las carreras que me interesan (por ejemplo, en algunas partes encuentro que la carrera que me gusta tiene un gran campo laboral, y en otras que no hay mucho trabajo en el área)'
  }
];

const baseInfo = {
  locale: 'es',
  title: '',
  completedHtml:
    '<div style="display: flex; justify-content: center; align-items: center; height: 40vh;"><h4>Guardando respuestas para avanzar...</h4></div>',
  startSurveyText: 'Continuar',
  showProgressBar: 'top',
  progressBarType: 'pages',
  goNextPageAutomatic: true,
  firstPageIsStarted: false,
  showPrevButton: true,
  showNavigationButtons: true,
  pageNextText: '→',
  pagePrevText: '←',
  // showQuestionNumbers: 'off',
  requiredText: ``,
  pages: ITEMS.map((item, index) => {
    return {
      name: item.code,
      title: '',
      elements: [
        questionHeader,
        {
          type: 'rating',
          name: item.code,
          title: item.text,
          isRequired: true,
          minRateDescription: 'No me representa para nada',
          maxRateDescription: 'Me representa muy bien',
          rateValues: ratingValues
        }
      ]
    };
  })
};

export default baseInfo;
